/** Moyenne de N−2, N−1 et N. Une année absente invalide la fenêtre, jamais d'interpolation.
 *
 * Recette du 19/10 (retour d'Olivier, log-9) : une fenêtre qui contient une année PARTIELLE
 * (l'année en cours, annoncée par le serveur dans `annee_partielle`) n'a pas de moyenne.
 * Quelques mois de permis ne sont pas une année, et la courbe plongeait à tort (« 363,667 » en
 * 2026 à Besançon).
 *
 * La moyenne rendue est EXACTE : la base 100 en a besoin (revue Codex du 20/10). L'arrondi à
 * l'unité des valeurs affichées en logements se fait dans `ChartBlock`, à l'affichage. */
export function moyenneMobile3Ans(annees: readonly (string | number)[],
                                 valeurs: readonly (number | null)[],
                                 anneesPartielles: ReadonlySet<number> = new Set()): (number | null)[] {
  const parAnnee = new Map(annees.map((a, i) => [Number(a), valeurs[i]]))
  return annees.map(a => {
    const ans = [Number(a) - 2, Number(a) - 1, Number(a)]
    if (ans.some(n => anneesPartielles.has(n))) return null
    const fenetre = ans.map(n => parAnnee.get(n))
    if (fenetre.some(v => v === null || v === undefined || !Number.isFinite(v))) return null
    return (fenetre as number[]).reduce((s, v) => s + v, 0) / 3
  })
}
